import {PostList} from "../post/postList";
import {getPost} from "../api";
import React, {useState} from "react";
import {useRouteNode} from "react-router5";
import {useTranslation} from "react-i18next";


function Bookmark({bookmarks,users}) {
  const { t } = useTranslation();
    const [posts,setPosts] = useState([]);
    const [init,setInit] = useState(false);
    const { router } = useRouteNode('profile.focus');
    if(!init){
        getFeed();
        setInit(true);
    }

    function getFeed(){
        Promise.all(
            bookmarks.map((id)=>{
              return getPost(id);
            })
        ).then((data)=> {
                setPosts(data);
            });
  }

  return <div className="c-container container_two containerBookmark" style={{width: "50%"}}>
      <div className="c-container_showedit-bar">
          <div className="c-showedit_bar-back-icon" onClick={()=>{ router.navigate('profile',{},{reload: true})}}/>
          <div className="c-showedit_text">{t('Mes Signets')}</div>
      </div>
      { posts.length>0 && <PostList users={users} apiCall={false} bookmarks={bookmarks} posts={posts} /> }
  </div>
}


export default Bookmark
